import cx from "classnames";
import React, { useEffect, useRef, useState } from "react";

import { TextBlock } from "../../types";
import { guessFontSize } from "./ZoneUtils";
import { Text } from "../InnodomContent/Text";
import { StateCallbacks } from "../../state";
import { extractHumanReadableText } from "../InnodomContent/util";
import { useOutsideClick } from "./useOutsideClick";

type Props = Readonly<{
  block: TextBlock;
  gutter: number;
  onShowReferences: (zoneId: string) => void;
  onAddCorrections:StateCallbacks["onAddCorrections"];
  onSelectBlock: (blockId: string, textContent: string, replace: boolean) => void;
  scale: number;
  selected: boolean;
}>;

const TextZoneComponent = ({
  block,
  gutter,
  onShowReferences,
  onAddCorrections,
  onSelectBlock,
  scale,
  selected,
}: Props) => {
  const [editorVisible, setEditorVisble] = useState(false);
  const ref: any = useRef();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setEditorVisble(false);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    }
  }, []);

  const style = {
    height: block.height * scale,
    left: block.x * scale + gutter,
    top: block.y * scale,
    width: block.width * scale,
  };

  return (
    <div>
      <div
        className={cx("zone", block.confidenceClass, { selected })}
        id={block.id}
        onClick={e => {
          if (e.altKey) {
            setEditorVisble(!editorVisible);
            return;
          }
          if (e.shiftKey && block.references.length > 0) {
            e.preventDefault();
            onShowReferences(block.id);
            return;
          }
          e.preventDefault();
          onSelectBlock(block.id, extractHumanReadableText(block.element), e.ctrlKey);
        }}
        style={style}
      />
      {editorVisible && 
        <div
          onBlur={() => {setEditorVisble(false)}}
          ref={ref}
          style={{
            ...style,
            userSelect: "text",
            top: style.top + style.height,
            left: style.left - 41, // Make room for the edit button
            width: style.width + 41,
            height: 1.2 * style.height + 20, // Bit of a buffer
            resize: "none",
            fontSize:  guessFontSize(block.text, style.height, style.width) + "px",
            position:"absolute",
            backgroundColor:"white",
            border: "1px solid black",
            paddingLeft:10,
            paddingRight:10,
            display:"flex",
            alignItems:"center",
            zIndex: 10000
          }}>
          <Text 
            block={block as TextBlock} 
            blocks={undefined}
            confirmTableSelection={undefined}
            disableTableSelectionConfirmation={undefined}
            id={`inlineEditor-${block.id}`}
            key={block.id}
            pages={undefined}
            selectedCell={null}
            setShowReferences={undefined}

            fontInformation={undefined}
            onAddCorrections={onAddCorrections}
            onSelectBlock={onSelectBlock}
            referencesLink={undefined}
            selected={selected}

            previewImage={undefined} />
        </div>
      }
    </div>
  );
};
TextZoneComponent.displayName = "TextZone";
export const TextZone = React.memo(TextZoneComponent);
